import { ControlConfig } from '../controlConfig';
import AddControlDate from './AddControlDate';
import ControlDateEngine from './ControlDateEngine';
import ControlDateEntry from './ControlDateEntry';
import ControlDatePlaceholder from './ControlDatePlaceholder';
import getLatestSchema from './schema';
import getDefaultValue from './getDefaultValue';
import getYupSchemaForDateEngine from './getYupSchemaForDateEngine';
import getYupSchemaForDateEntry from './getYupSchemaForDateEntry';
import translator from './translator';

export default {
  getDefaultValue,
  getLatestSchema,
  Engine: ControlDateEngine,
  Entry: ControlDateEntry,
  Add: AddControlDate,
  yupSchemaEngine: getYupSchemaForDateEngine,
  yupSchemaEntry: getYupSchemaForDateEntry,
  translator,
  Placeholder: ControlDatePlaceholder,
  previewCardHeight: '120px'
} as ControlConfig;
